module.exports = __webpack_public_path__ + "img/serwis-elektryki.0c578ab5.jpg";